import React, { useState, useEffect } from "react";
import { useTable, useSortBy } from "react-table";
import { BtnEdit, BtnDeletar, SemDados } from "./Base";
import { Checkbox } from "antd";
import moment from "moment";

const culture = new Intl.NumberFormat("pt-BR", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const cultureN0 = new Intl.NumberFormat("pt-BR", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function getAlign(column) {
  if (column.tipo === "rs" || column.tipo === "int" || column.tipo === "dec" || column.tipo === "right") {
    return "right";
  }

  return "left";
}

function getValue(cell, column) {
  if (column.tipo === "rs") {
    return `R$ ${culture.format(cell.value)}`;
  } else if (column.tipo === "dec") {
    return culture.format(cell.value);
  } else if (column.tipo === "int") {
    return cultureN0.format(cell.value);
  } else if (column.tipo === "dt") {
    return moment(cell.value).format("DD/MM/YYYY");
  } else if (column.tipo === "dthr") {
    return moment(cell.value).format("DD/MM/YYYY hh:mm:ss");
  }

  return cell.render("Cell");
}

export default function Table(props) {
  if (!props.data || !props.data.length) {
    return <SemDados style={{ marginTop: 50 }} />;
  }

  return <TableDet {...props} />;
}

function TableDet({ columns, data, setEdit, onDelete, setMarcados: setMarca, showChk, ...rest }) {
  // Use the state and functions returned from useTable to build your UI

  const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { marcados, marcar, indeterminate, allChecked, checkAll } = useChk(data);
  const hasFooter = React.useMemo(() => columns.filter(x => !!x.Footer).length > 0, [columns]);
  const hasChk = React.useMemo(() => !!setMarca, [setMarca]);
  // console.log('rows', rows);

  useEffect(() => {
    if (!!setMarca) {
      setMarca(marcados);
    }
  }, [marcados]);

  // Render the UI for your table
  return (
    <table className="tabela-padrao" {...rest} {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {hasChk && (
              <th>
                <Checkbox indeterminate={indeterminate} onChange={checkAll} checked={allChecked} />
              </th>
            )}
            {/* {hasChk && <th></th>} */}
            {headerGroup.headers.map((column, inxC) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                style={{
                  cursor: "pointer",
                  textAlign: getAlign(columns[inxC]),
                }}
              >
                {column.render("Header")}
              </th>
            ))}
            <th></th>
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          console.log("row render");
          return (
            <Row key={i} hasChk={hasChk} row={row} columns={columns} marcados={marcados} marcar={marcar} setEdit={setEdit} onDelete={onDelete} />
            // <Row key={i} hasChk={hasChk} row={row} columns={columns} marcar={marcar} setEdit={setEdit} />
          );
        })}
      </tbody>
      <tfoot>
        {hasFooter &&
          footerGroups.map(group => (
            <tr {...group.getFooterGroupProps()}>
              {hasChk && <td></td>}
              {group.headers.map((column, inxC) => (
                <td {...column.getFooterProps()} style={{ textAlign: getAlign(columns[inxC]) }}>
                  {columns[inxC].Somar ? culture.format(rows.reduce((sum, row) => row.values[columns[inxC].accessor] + sum, 0)) : column.render("Footer")}
                </td>
              ))}
              <td></td>
            </tr>
          ))}
      </tfoot>
    </table>
  );
}

// const Row = React.memo(({hasChk, row, columns, marcar, setEdit}) => {
const Row = React.memo(({ hasChk, row, columns, marcados, marcar, setEdit, onDelete }) => {
  // console.log('row rendered');
  return (
    <tr {...row.getRowProps()}>
      {hasChk && (
        <td>
          <Checkbox checked={marcados.includes(row.original.id)} onChange={e => marcar(row.original.id, e.target.checked)} />
        </td>
      )}
      {/* {hasChk && <td><Checkbox onChange={e => marcar(row.original.id, e.target.checked)}/></td>} */}
      {row.cells.map((cell, inx) => {
        const c = columns[inx];
        return (
          <td {...cell.getCellProps()} style={{ textAlign: getAlign(c) }}>
            {getValue(cell, c)}
          </td>
        );
      })}
      <td className="td-icon" style={{ textAlign: "right" }}>
        {setEdit && <BtnEdit onClick={() => setEdit(row.original)} />}
        {onDelete && <BtnDeletar onOk={() => onDelete(row.original)} />}
      </td>
    </tr>
  );
});

function useChk(data) {
  const [marcados, setMarcados] = useState([]);

  const [allChecked, indeterminate] = React.useMemo(() => {
    if (!marcados || marcados.length === 0) {
      return [false, false];
    }

    if (marcados.length >= data.length) {
      return [true, false];
    } else {
      return [false, true];
    }
  }, [marcados]);

  const marcar = React.useCallback(
    (id, checked) => {
      setMarcados(marcados => {
        if (!checked) {
          return marcados.filter(x => x != id);
        } else {
          return [...marcados, id];
        }
      });
    },
    [setMarcados]
  );

  const checkAll = React.useCallback(() => {
    setMarcados(!allChecked ? (data || []).map(x => x.id) : []);
  }, [allChecked, data, setMarcados]);

  return { marcados, marcar, indeterminate, allChecked, checkAll };
}
